import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Formatea un monto como moneda (dólares estadounidenses) para la UI del carrito. */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);
}

/**
 * Sanea un fragmento `ts_headline` del backend para renderizarlo como HTML.
 * `ts_headline` no escapa el texto original, así que escapamos todo y luego
 * restauramos únicamente las etiquetas `<mark>`/`</mark>` que insertamos en la
 * query. Cualquier otro `<`/`>`/`&` del nombre del producto queda neutralizado,
 * evitando inyección de HTML aunque el dato viniera contaminado.
 */
export function sanitizeHighlight(html: string): string {
  const MARK_OPEN = ' MARK_OPEN ';
  const MARK_CLOSE = ' MARK_CLOSE ';
  return html
    .replaceAll('<mark>', MARK_OPEN)
    .replaceAll('</mark>', MARK_CLOSE)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll(MARK_OPEN, '<mark>')
    .replaceAll(MARK_CLOSE, '</mark>');
}
